// Display labels for the segment_category enum stored in the database.
// The DB value 'external' is shown to users as "Roadside".
const CATEGORY_DISPLAY = {
  internal: 'internal',
  external: 'roadside',
  courtesy: 'courtesy',
  fragment: 'fragment',
  expansion: 'expansion',
};

// Short label used in the category badges (segment list / segment panel).
export function categoryLabel(category) {
  const key = category || 'internal';
  return CATEGORY_DISPLAY[key] || key.replace(/_/g, ' ');
}

// Expansion segments: proposed trail, not yet part of the formal system.
// Order is the path to adoption; keep in step with backend utils/segmentVisibility.js.
export const EXPANSION_STATUSES = [
  ['identified', 'Identified'],
  ['owner_contacted', 'Owner contacted'],
  ['negotiating', 'In discussion'],
  ['agreement_pending', 'Agreement pending'],
  ['on_hold', 'On hold'],
  ['declined', 'Owner declined'],
];

export function expansionStatusLabel(status) {
  const found = EXPANSION_STATUSES.find(([value]) => value === status);
  return found ? found[1] : (status || '').replace(/_/g, ' ');
}

export const CONTACT_METHODS = [
  ['in_person', 'In person'],
  ['phone', 'Phone'],
  ['email', 'Email'],
  ['letter', 'Letter'],
  ['other', 'Other'],
];

export function contactMethodLabel(method) {
  const found = CONTACT_METHODS.find(([value]) => value === method);
  return found ? found[1] : method;
}
